<template>
  <div>
    <FabricTable @check="addFabric" />

    <h6 style="color: #101010" class="mt-3">
      {{ $l('form_header_chooseFabric') || '已选择面料' }}
    </h6>
    <el-form
      ref="form"
      v-for="(fabric, index) in listFabric"
      :key="index"
      :model="fabric"
      :rules="rules"
      size="mini"
    >
      <div class="d-flex flex-row">
        <div class="mr-3">
          <el-image
            fit="cover"
            style="width: 120px; height: 80px"
            :src="fabric.displayImageUrl"
            :preview-src-list="[fabric.displayImageUrl]"
          >
            <div slot="error">
              <img src="/image/static/img/nopic.jpg" />
            </div>
          </el-image>
          <div class="text-center">
            <el-tooltip
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="bottom"
            >
              <i
                class="el-icon-delete tool-btn text-danger"
                @click="delFabric(index)"
              />
            </el-tooltip>
          </div>
        </div>
        <div class="flex-grow-1">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_fabricPosition') || '面料位置'"
                prop="fabricPositionCode"
              >
                <dict-select
                  v-model="fabric.fabricPositionCode"
                  :selectedLabel.sync="fabric.fabricPositionName"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'fabricPosition' }"
                  filterable
                  clearable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_fabricColorNo') || '面料编号'"
              >
                <el-input v-model="fabric.fabricColorNo" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                :label="$l('form_label_displayFabricName') || '面料名称'"
              >
                <el-input v-model="fabric.displayFabricName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_fabricContent') || '面料成分（中文）'"
              >
                <el-input v-model="fabric.fabricContent" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_fabricContentEn') || '面料成分（英文）'"
              >
                <el-input v-model="fabric.fabricContentEn" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_displayFabricWeight') || '面料克重'"
              >
                <el-input v-model="fabric.displayFabricWeight" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$l('form_label_yarnCount') || '纱支'">
                <el-input v-model="fabric.yarnCount" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$l('form_label_density') || '密度'">
                <el-input v-model="fabric.density" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <EmptyContent
      v-if="!listFabric || !listFabric.length"
      :text="$l('table_empty_fabric') || '请选择面料'"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ this.$l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ this.$l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ this.$l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import FabricTable from './components/fabric-table'
import EmptyContent from '../empty-content'
const initFabric = { fabricPositionCode: '', fabricPositionName: '' }
export default {
  components: { FabricTable, EmptyContent },
  props: { data: { type: Array, default: () => [] } },
  data() {
    return {
      backDialogVisible: false,
      listFabric: [],
      rules: {
        fabricPositionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    data: {
      handler(v) {
        this.listFabric = [...(v || [])]
      },
      immediate: true,
    },
  },
  mounted() {
    // this.listFabric = this.data
  },
  methods: {
    addFabric(fabric) {
      const {
        fabricName,
        fabricColorTitle,
        defaultImageUrl,
        fabricWeight,
        v_fabricWeightUnit,
      } = fabric
      const displayFabricName = [fabricName, fabricColorTitle]
        .filter(Boolean)
        .join(' ')
      const displayFabricWeight = [fabricWeight, v_fabricWeightUnit]
        .filter(Boolean)
        .join(' ')

      const displayImageUrl = defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
      this.listFabric.push({
        ...fabric,
        ...initFabric,
        displayFabricName,
        displayFabricWeight,
        displayImageUrl,
      })
    },
    async delFabric(index) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listFabric.splice(index, 1)
    },
    async validate() {
      const empty = !this.listFabric?.length
      if (empty) {
        this.$message({ message: '请选择面料信息', type: 'warning' })
      }

      // 校验是否存在同一款面料位置重复
      let isRepeat = false
      if (!empty) {
        const repeat = this.listFabric.find((fabric) => {
          const { fabricColorCode, fabricPositionCode } = fabric
          const fabricKey = [fabricColorCode, fabricPositionCode]
            .filter(Boolean)
            .join('-')
          const list = this.listFabric.filter((item) => {
            const key = [item.fabricColorCode, item.fabricPositionCode]
              .filter(Boolean)
              .join('-')
            return fabricKey === key
          })
          return list.length > 1
        })

        isRepeat = !!repeat

        if (isRepeat) {
          this.$message({
            message: `面料[${repeat.fabricColorNo}]存在相同面料位置，请检查`,
            type: 'warning',
          })
        }
      }

      const result = await validate.formValidate(this.$refs.form)
      return result && !empty && !isRepeat
    },
    async save() {
      const result = await this.validate()
      if (!result) return (this.backDialogVisible = false)
      this.$emit('confirm', this.listFabric)
      this.close()
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form {
  background-color: #f4f6f9;
  padding: 16px;
  padding-bottom: 6px;
  border-radius: 5px;
  margin-bottom: 16px;
  .tool-btn {
    font-size: 22px;
  }
}
</style>
